export default __webpack_public_path__ + "static/media/section1-bg2.f32a570d.svg";